import AbstractObserver from './abstract';
import slideUp from '../utils/slide-up';
import slideDown from '../utils/slide-down';

export default class HSHeaderHasHiddenElement extends AbstractObserver {
  constructor(element) {
    super(element);
    this.config = {
      animated: true,
    };
    this.dataSettings = this.element.hasAttribute('data-ua-header-options')
      ? JSON.parse(this.element.getAttribute('data-ua-header-options'))
      : {};
  }

  init() {
    this.offset = isFinite(this.dataSettings.fixMoment) ? this.dataSettings.fixMoment : 5;
    this.elements = this.element.querySelectorAll('.navbar-hidden-element');
    this.defaultState = true;

    return this;
  }

  destroy() {
    this.toDefaultState();

    return this;
  }

  check() {
    if (!this.elements.length) {
      return this;
    }

    const docScrolled = window.scrollY;

    if (docScrolled > this.offset && this.defaultState) {
      this.changeState();
    } else if (docScrolled <= this.offset && !this.defaultState) {
      this.toDefaultState();
    }

    return this;
  }

  changeState() {
    this.toggleElements('none', slideUp);
    this.defaultState = !this.defaultState;

    return this;
  }

  toDefaultState() {
    this.toggleElements('block', slideDown);
    this.defaultState = !this.defaultState;

    return this;
  }

  toggleElements(displayStyle, animationFunction) {
    if (this.config.animated) {
      this.elements.forEach((item) => {
        animationFunction(item);
      });
    } else {
      this.elements.forEach((item) => {
        item.style.display = displayStyle;
      });
    }
  }
}
